import axios from "axios";

// At build time, REACT_APP_BACKEND_URL is baked in (Emergent host). But in production
// we serve the app on a custom domain (e.g. speakup.dhwaniris.in) that ALSO routes
// /api/* to the backend — so we should hit the same origin as the loaded page to keep
// things same-origin and avoid CORS entirely. In dev/SSR contexts where `window` is
// absent, we fall back to the build-time env var.
const ENV_BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
const RUNTIME_BACKEND_URL =
    typeof window !== "undefined" && window.location?.origin ? window.location.origin : ENV_BACKEND_URL;
export const API = `${RUNTIME_BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    withCredentials: true,
    headers: { "Content-Type": "application/json" },
});

/** Detect dominant script in a string and return a CSS class for font-family. */
export function scriptClass(text) {
    if (!text) return "";
    if (/[\u0900-\u097F]/.test(text)) return "lang-deva";
    if (/[\u0B80-\u0BFF]/.test(text)) return "lang-taml";
    return "";
}

/** Best-effort language name from BCP-47 code. */
export function langLabel(code) {
    const map = {
        "hi-IN": "Hindi",
        "en-IN": "English",
        "ta-IN": "Tamil",
        "te-IN": "Telugu",
        "bn-IN": "Bengali",
        "mr-IN": "Marathi",
        "gu-IN": "Gujarati",
        "kn-IN": "Kannada",
        "ml-IN": "Malayalam",
        "pa-IN": "Punjabi",
    };
    if (!code) return "Detected";
    return map[code] || code;
}

export function fmtMoney(n) {
    if (n == null || n === "") return "—";
    try {
        return "₹" + Number(n).toLocaleString("en-IN");
    } catch {
        return "₹" + n;
    }
}

export function fmtDate(s) {
    if (!s) return "—";
    try {
        return new Date(s).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
    } catch {
        return s;
    }
}

export const LEVEL_LABELS = {
    1: "Customer Care",
    2: "Nodal Officer",
    3: "Principal Nodal Officer",
    4: "RBI Ombudsman",
};
